import React, { useEffect, useCallback, useState} from 'react';
import FormantsEditor from './FormantsEditor.js';
import {connect} from 'react-redux';
import ConditionedComponent from 'components/ConditionedComponent.js';
import CheckboxParameter from 'components/effects/CheckboxParameter.js';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';

const OperatorDetails = ({oscillator, formantsExpanded, setFormantsExpanded}) => { 
    return (
        <div className="operator-details">
          {!formantsExpanded &&
          <div className="volume-and-detune">
            <EffectParameterSlider
              sequencerEngine={oscillator.sequencerEngine}
              name={'Volume'}
              parameter={oscillator.oscillatorLevelParameter}
              onParameterChanged={() => []}
              isParameter={true}
              lfoEnabled={true}
              min={0}
              max={1}
              step={0.01}
            />
            <EffectParameterSlider
              name={'Detune'}
              sequencerEngine={oscillator.sequencerEngine}
              lfoEnabled={true}
              parameter={oscillator.detuneParameter}
              onParameterChanged={() => []}
              isParameter={true}
              min={-100}
              max={100}
              step={1}
            />
            <EffectParameterSlider
              sequencerEngine={oscillator.sequencerEngine}
              name={'Octave'}
              parameter={oscillator.oscillatorOctaveParameter}
              convertToRoot={2}
              onParameterChanged={() => []}
              isParameter={true}
              lfoEnabled={true}
              min={-4}
              max={4}
              step={1}
            />
          </div>
          }
          {!formantsExpanded && 
          <div className="volume-and-detune">
            <ConditionedComponent
              condition={oscillator.oscillatorTypeParameter.get() &&
                         oscillator.oscillatorTypeParameter.get().includes('fat')}>
            <EffectParameterSlider
              sequencerEngine={oscillator.sequencerEngine}
              name={'Count'}
              parameter={oscillator.countParameter}
              onParameterChanged={() => []}
              isParameter={true}
              lfoEnabled={true}
              min={3}
              max={9}
              step={1}
            />
             <EffectParameterSlider
              sequencerEngine={oscillator.sequencerEngine}
              name={'Spread'}
              parameter={oscillator.spreadParameter}
              onParameterChanged={() => []}
              isParameter={true}
              lfoEnabled={true}
              min={1}
              max={200}
              step={0.01}
            />
 
            </ConditionedComponent>
          <ConditionedComponent condition={oscillator.oscillatorTypeParameter.get() === 'pulse'}>
            <EffectParameterSlider
              sequencerEngine={oscillator.sequencerEngine}
              name={'Pulse'}
              parameter={oscillator.pulseWidthParameter}
              onParameterChanged={() => []}
              isParameter={true}
              lfoEnabled={true}
              min={0}
              max={1}
              step={0.01}
            />
          </ConditionedComponent>
          </div>
          }
          <FormantsEditor formantsExpanded={formantsExpanded} setFormantsExpanded={setFormantsExpanded} oscillator={oscillator}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OperatorDetails);
